import {Component, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

@Component({
  selector: 'sorted-bar-chart',
  templateUrl: './sorted-bar-chart.component.html',
  styleUrl: './sorted-bar-chart.component.scss'
})



export class SortedBarChartComponent implements OnInit, OnDestroy {
  private root!: am5.Root;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    // Create root element
    // Create root element
    this.root = am5.Root.new(this.elementRef.nativeElement.querySelector('#chartdiv'));

    // Set themes
    this.root.setThemes([am5themes_Animated.new(this.root)]);

    // Create chart
    const chart = this.root.container.children.push(am5xy.XYChart.new(this.root, {
      panX: false,
      panY: false,
      wheelX: "none",
      wheelY: "none",
      paddingLeft: 0
    }));

    // Rest of your chart configuration...
    // [Previous implementation continues here...]
  }

  ngOnDestroy(): void {
    if (this.root) {
      this.root.dispose();
    }
  }
}
